import { render } from "./LoadingCard.vue?vue&type=template&id=59d1ae4c"
import script from "./LoadingCard.vue?vue&type=script&lang=js"
export * from "./LoadingCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LoadingCard.vue"]])

export default __exports__